import { PageTitleMenuItem } from "../../../toolympus/components/primitives/PageTitleMenu";

export const CopTreeMenu: PageTitleMenuItem[] = [
  {
    key: "decisions",
    label: "Decisions",
    path: "/cop-decision"
  },
  {
    key: "conferences",
    label: "Conferences",
    path: "/cop/tree/conferences"
  },
  {
    key: "tree",
    label: "Tree",
    path: "/cop/tree/tree"
  },
]